import { HOW_IT_WORKS, HOW_IT_WORKS_IMAGE } from '../content/site';

export function HowItWorks() {
  return (
    <section id="how-it-works" className="section bg-surface-alt">
      <div className="container-content">
        <div className="mx-auto max-w-2xl text-center">
          <span className="eyebrow">How it works</span>
          <h2 className="mt-4 font-heading text-3xl font-bold text-ink-900 sm:text-4xl">
            From application to winner story in four steps
          </h2>
        </div>

        <figure className="mx-auto mt-10 max-w-4xl overflow-hidden rounded-3xl border border-line bg-white shadow-card">
          <video
            className="aspect-[16/9] w-full object-cover"
            poster={HOW_IT_WORKS_IMAGE}
            playsInline
            controls
            preload="metadata"
            aria-label="Corporate partnerships explainer — how a sponsored skill-based campaign works, end to end"
          >
            <source src="/studio/video/corporate-explainer-tv.mp4" type="video/mp4" />
          </video>
          <figcaption className="px-5 py-3 text-center text-sm text-ink-500">
            Watch: how a sponsored skill-based campaign works
          </figcaption>
        </figure>

        <ol className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {HOW_IT_WORKS.map((item) => (
            <li key={item.step} className="rounded-2xl bg-white p-6 shadow-card">
              <span className="grid h-11 w-11 place-items-center rounded-full bg-aurora font-heading text-lg font-bold text-white">
                {item.step}
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold text-ink-900">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink-700">{item.description}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}

export default HowItWorks;
